__turbopack_context__.v({
  "fullWidth": "SearchBar-module__2_MXCa__fullWidth",
  "loadingIcon": "SearchBar-module__2_MXCa__loadingIcon",
  "searchContainer": "SearchBar-module__2_MXCa__searchContainer",
  "searchIcon": "SearchBar-module__2_MXCa__searchIcon",
  "searchIconSmall": "SearchBar-module__2_MXCa__searchIconSmall",
  "searchInput": "SearchBar-module__2_MXCa__searchInput",
  "spin": "SearchBar-module__2_MXCa__spin",
  "suggestionContent": "SearchBar-module__2_MXCa__suggestionContent",
  "suggestionIcon": "SearchBar-module__2_MXCa__suggestionIcon",
  "suggestionItem": "SearchBar-module__2_MXCa__suggestionItem",
  "suggestionItemActive": "SearchBar-module__2_MXCa__suggestionItemActive",
  "suggestionMainText": "SearchBar-module__2_MXCa__suggestionMainText",
  "suggestionSecondaryText": "SearchBar-module__2_MXCa__suggestionSecondaryText",
  "suggestionsDropdown": "SearchBar-module__2_MXCa__suggestionsDropdown",
});
